<i class='fal fa-edit me-2 text-primary' (click)="edit()" *ngIf="params.edit"></i>
<i class='fal fa-trash-alt text-red' (click)="delete()" *ngIf="params.delete"></i>
<mat-slide-toggle *ngIf="params?.props?.isToggle" [(ngModel)]="params.data.dismiss" class="mat-slide-toggle-sm checklist-leaf-node me-auto" (change)= toggleValue()> 
</mat-slide-toggle>